const form = {
  formId: "new-user-form",
  formField: {
    taxId: {
      name: "taxId",
      label: "Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    conpanyName: {
      name: "conpanyName",
      label: "Tên tổ chức cá nhân",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên tổ chức cá nhân:",
      invalidMsg: "tên tổ chức cá nhân không hợp lệ",
    },
    creator: {
      name: "creator",
      label: "Người lập biểu",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người lập biểu",
    },
    sendTo: {
      name: "sendTo",
      label: "Kính gửi",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập nơi muốn gửi",
    },
    method: {
      name: "method",
      label: "Phương pháp hủy biên lai",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập phương pháp hủy biên lai thu tiền phí, lệ phí",
    },
    date: {
      name: "date",
      label: "Ngày,giờ thông báo hủy biên lai thu tiền phí, lệ phí",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập ngày,giờ mất,cháy,hỏng biên lai",
    },
    releaseDate: {
      name: "releaseDate",
      label: "Ngày Lập báo cáo",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập ngày lập báo cáo",
    },
    representative: {
      name: "representative",
      label: "Người đại diện theo pháp luật",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người đại diện",
    },
  },
};

export default form;
